import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ActionRequired from "./pages/ActionRequired";
import CalendarPage from "./pages/CalendarPage";
import MissedRenewals from "./pages/MissedRenewals";
import DataQuality from "./pages/DataQuality";
import Management from "./pages/Management";
import IllPayments from "./pages/IllPayments";
import Masters from "./pages/Masters";
import History from "./pages/History";
import Users from "./pages/Users";
import CircuitDetail from "./pages/CircuitDetail";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import AddCustomerLink from "./pages/AddCustomerLink";
import Invoices from "./pages/Invoices";
import Settings from "./pages/Settings";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/action-required" element={<Protected><ActionRequired /></Protected>} />
            <Route path="/calendar" element={<Protected><CalendarPage /></Protected>} />
            <Route path="/missed-renewals" element={<Protected><MissedRenewals /></Protected>} />
            <Route path="/data-quality" element={<Protected><DataQuality /></Protected>} />
            <Route path="/management" element={<Protected><Management /></Protected>} />
            <Route path="/ill-payments" element={<Protected><IllPayments /></Protected>} />
            <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
            <Route path="/masters" element={<Protected><Masters /></Protected>} />
            <Route path="/history" element={<Protected><History /></Protected>} />
            <Route path="/users" element={<Protected><Users /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/customers" element={<Protected><Customers /></Protected>} />
            <Route path="/customers/:id" element={<Protected><CustomerDetail /></Protected>} />
            <Route path="/customer-link" element={<Protected><AddCustomerLink /></Protected>} />
            <Route path="/customer-link/:connectionId" element={<Protected><AddCustomerLink /></Protected>} />
            <Route path="/circuit/:id" element={<Protected><CircuitDetail /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
